<div class="modal">
  <div class="modal-ctn picker">

    <div class="mission">
      <a>MISSION</a>
      <a>{{ 'MISSIONS.FLOWRATE' | translate }}: {{ mission.DMDSExpectedMinFlowrate | number : '1.0-2' }} - {{ mission.DMDSExpectedMaxFlowrate | number : '1.0-2' }} {{ mission.volumeFlowrateUom }}</a>
      <a>{{ 'MISSIONS.INJECTION_PRESSURE' | translate }}: {{ mission.unitDMDSInjectionPointPressure | number : '1.0-2' }} {{ mission.pressureUom }}</a>
    </div>

    <div class="options">
      <span class="picker-title">{{ 'UI.PICK.SKID' | translate }}</span>
      <df-input type="search" prefixIcon="heroMagnifyingGlass" allowClear (valueChange)="filterSkids($event)" />
      <button type="button" class="icon-action" title="Close" (click)="close()"><ng-icon name="heroXMark" size="20"/></button>
    </div>

    @if (showTrainSelector) {
      <div class="picker-train">
        <df-form-field [label]="'UI.NEW_MISSION.TRAIN' | translate">
          <df-select inputId="skidTrain" [placeholder]="'UI.SELECT' | translate"
            [options]="trainOptions" [formControl]="selectedTrainFC" />
        </df-form-field>
      </div>
    }

    <div class="skids picker-list">
      @for (skid of displayedSkids; track skid) {
        <div class="skid picker-item" [class.no-digital]="isNoDigital(skid)">
          <div class="logo">
            <div class="equipments">
              @if (skid.hasPump) {
                <ng-icon name="heroCog6Tooth" size="18"/>
              }
              @if (skid.hasFlowmeter) {
                <ng-icon name="heroArrowsRightLeft" size="18"/>
              }
              @if (skid.hasGateway) {
                <ng-icon name="heroSignal" size="18"/>
              }
            </div>
            <a>{{ skid.skidName }}</a>
          </div>
          <div class="info">
            @if (!isNoDigital(skid)) {
              @if (skid.hasPump) {
                <a>{{ 'SKID.FLOWRATE' | translate }}: {{ skid.pumpFlowrateRange }} {{ mission.volumeFlowrateUom }}</a>
                <a>{{ 'SKID.MAX_PRESSURE' | translate }}: {{ skid.pumpMaxPressure }} {{ mission.pressureUom }}</a>
                <a>{{ 'SKID.PUMP_MODELSUPPLIER' | translate }}: {{ skid.pumpmodelSupplier }}</a>
                <a>{{ 'SKID.PUMP_TYPE' | translate }}: {{ skid.pumpmodelName }}</a>
              }
              @if (skid.hasGateway) {
                <a>{{ 'MISSION_SKID.GATEWAY' | translate }}: {{ skid.gatewayName }}</a>
              }
              @if (skid.hasFlowmeter) {
                <a>{{ 'MISSION_SKID.FLOWMETER' | translate }}: {{ skid.flowmeterName }}</a>
              }
            }
          </div>
          <df-button size="sm" variant="primary" class="add" [disabled]="selectedTrainFC.invalid"
            (onClick)="addSkid(skid)">{{ 'UI.SELECT' | translate }}</df-button>
        </div>
      }
    </div>

  </div>
</div>
